import React from "react";

import { Button, Section, OneColumnStack, IconButton } from "@arp/react-ndbx";
import { Stack } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useOutletContext } from "react-router-dom";

export default function ButtonNavigationGroup({ ...props }) {
  const {
    showBackButton = true,
    showNextButton = true,
    next = "..",
  } = { ...props };
  const {
    isDirty: [isDirty],
    isValid: [isValid],
    isSubmitting: [isSubmitting],
    errors: [errors],
    onBackButton: [onBackButton],
  } = useOutletContext();

  function anyErrors() {
    const foundErrors = Object?.keys(errors).length > 0 ? true : false;
    return foundErrors;
  }

  return (
    <OneColumnStack>
      <Stack
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {showNextButton && (
          <Section md={12} mt={4}>
            <Button
              id="next-button"
              ariaLabel="Next"
              color="primary"
              variant="block"
              label="Primary"
              size="medium"
              type="submit"
              disabled={!isDirty || !isValid || isSubmitting}
            >
              Next
            </Button>
          </Section>
        )}
        {showBackButton && (
          <Section md={8} mt={2} ml={-4}>
            <IconButton
              name="Q1"
              icon={<ArrowBackIcon />}
              position="start"
              label="Back"
              variant="icon-button"
              onClick={onBackButton}
              disabled={isSubmitting}
            >
              Back
            </IconButton>
          </Section>
        )}
      </Stack>
    </OneColumnStack>
  );
}
